export * from './loading/Loading';
export * from './loading/SmallLoading';
export * from './header/Header';
export * from './nav/Nav';
export * from './h1/H1';
export * from './error/Error';

export const modalStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
		zIndex: 9999,
		boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.50)',
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
};



// WEBPACK FOOTER //
// ./src/components/common/index.js